export default __webpack_public_path__ + "static/media/levelBackgroundNew.a1c01079.svg";